import { css, cx } from "@emotion/css";

import { useTheme } from "@/modules/theme/hooks/useTheme";
import { grey, white } from "@/modules/theme/utils/colors";
import { Theme } from "@/modules/theme/utils/createTheme";

interface AvatarProps {
  name: string;
  className?: string;
}

export function Avatar({ name, className }: AvatarProps) {
  const classes = createStyles(useTheme());

  return <div className={cx(classes.root, className)}>{getInitials(name)}</div>;
}

function createStyles({ typography, spacing }: Theme) {
  return {
    root: css({
      height: spacing(6.5),
      width: spacing(6.5),
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: grey[200],
      borderRadius: "50%",
      color: white,
      fontSize: typography.pxToRem(18),
    }),
  };
}

function getInitials(name: string) {
  return name
    .split(" ")
    .map((word) => word.charAt(0))
    .join("")
    .toUpperCase();
}
